import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Mark every non-home page with body.kl-not-home so the global
    // .kl-scroll-fade rule in App.css keeps the floating Trending ticker,
    // Skin Tip dock, Crown Reserve dock, AI Photo Analysis, and Audio
    // bubbles dimmed to 5% throughout the entire visit. Home stays full
    // opacity so the lobby experience isn't affected.
    const isHome = pathname === "/" || pathname === "/book" || pathname === "/last-minute";
    document.body.classList.toggle("kl-not-home", !isHome);

    // ── Hash-aware scrolling ───────────────────────────────────────────
    // When a route includes a hash (e.g. `/laser-and-skin#addons`), jump
    // to that section's anchor instead of forcing the user back to the
    // top. This makes in-app deep-links from the homepage Treatment
    // category grid (Add-On Glow Boosters → #addons) actually land on
    // the right section. Falls back to top-scroll for plain routes.
    const targetId = (hash || "").replace(/^#/, "");
    if (targetId) {
      // Nov 3 2026 · Karine: "/laser-and-skin#chemical-peels shows no chemical
      // peel". The page is lazy-loaded and 40k px tall, so the anchor often
      // mounts well after 250ms and the layout keeps shifting as images load.
      // Poll for up to 6s, re-aligning when the anchor moves, then stop.
      let settledAt = null;
      let lastTop = null;
      const start = Date.now();
      const tick = setInterval(() => {
        const el = document.getElementById(targetId);
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY;
          if (lastTop === null || Math.abs(top - lastTop) > 4) {
            window.scrollTo({ top: Math.max(0, top - 72), behavior: lastTop === null ? "auto" : "auto" });
            lastTop = top;
            settledAt = Date.now();
          } else if (settledAt && Date.now() - settledAt > 1500) {
            clearInterval(tick);
          }
        }
        if (Date.now() - start > 6000) clearInterval(tick);
      }, 120);
      // If the client starts scrolling themselves, stop re-aligning immediately.
      const stop = () => clearInterval(tick);
      window.addEventListener("wheel", stop, { passive: true, once: true });
      window.addEventListener("touchstart", stop, { passive: true, once: true });
      return () => { clearInterval(tick); window.removeEventListener("wheel", stop); window.removeEventListener("touchstart", stop); };
    }

    // No hash — original behavior: snap to top, plus a 100ms safety net
    // to override any race-condition scroll restorers.
    window.scrollTo(0, 0);
    const timer = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    return () => clearTimeout(timer);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
